export const LOGIN = "/Login";
export const HOME = "/";
export const EDIT = "/calculation";
export const PIECHART = "/user-statistics";
export const COFFEE = "/food-section";
export const PROFILE = "/profile";
